import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from '@angular/forms';
import { DateUtilsService, TranslationService } from '@sdbn/common';
import { Transport, TransportReceiver } from 'src/tmc-yard/common/model/transport.model';
import { DateTime } from 'luxon';

@Component({
  selector: 'app-preloading-field',
  templateUrl: './preloading-field.component.html',
  styleUrls: ['./preloading-field.component.scss']
})
export class PreloadingFieldComponent implements OnInit, TransportReceiver {

  transport: Transport;

  formGroup = new FormGroup({
    active: new FormControl(false, []),
    date: new FormControl(new Date(), [])
  });

  constructor(
    public translationService: TranslationService,
    private dateUtils: DateUtilsService
  ) {

  }

  changing = false;

  ngOnInit(): void {

    this.formGroup.valueChanges.subscribe(value => {

      if (this.changing) {
        return;
      }

      let changed = this.transport.masterdata.preloading !== value.active;

      this.transport.masterdata.preloading = value.active;

      if (changed && value.active && this.transport.masterdata.preloadingDate == null) {
        this.changing = true;
        this.transport.masterdata.preloadingDate = DateTime.fromJSDate(new Date()).toFormat("yyyyMMddHHmm00");
        this.formGroup.patchValue({
          active: this.transport.masterdata.preloading,
          date: this.dateUtils.formatTimestampToDateString(this.transport.masterdata.preloadingDate)
        });
        this.changing = false;
      } else {
        this.transport.masterdata.preloadingDate = value.active ? this.dateUtils.formatDateStringToTimestamp(value.date) : null;
      }
    });

  }

  public setTransport(value: Transport) {
    console.log('setting transport to preloading field', value);
    this.transport = value;

    console.log('patching preloading details', this.transport.masterdata.preloading,
      this.dateUtils.formatTimestampToDateString(this.transport.masterdata.preloadingDate));

    this.formGroup.patchValue({
      active: this.transport.masterdata.preloading,
      date: this.transport.masterdata.preloading ? this.dateUtils.formatTimestampToDateString(this.transport.masterdata.preloadingDate) : null
    });

  }

}
